import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { BasicService } from './basic.service';

export interface MasterCatalogFilters {
  item_code?: string;
  item_name?: string;
  barcode?: string;
  vendor_code?: string;
  vendor_name?: string;
  vendor_item_code?: string;
}

export interface MasterSuppliersFilters {
  supplier_id?: string;
  supplier_name?: string;
  supplier_erp_code?: string;
  status?: string;
}

@Injectable({
  providedIn: 'root'
})
export class MasterCatalogService {

  constructor(private http: HttpClient, private basicService: BasicService) { }

  private authHeaders(): Record<string, string> {
    const headers: Record<string, string> = {
      'Content-Type': 'application/json'
    };
    const userData = this.basicService.user_data || this.basicService.getItem('user_data');
    if (userData && (userData.loginToken || userData.apiKey)) {
      headers['Authorization'] = 'Bearer ' + (userData.loginToken || userData.apiKey);
    }
    return headers;
  }

  getVendorNames() {
    const url = environment.auth_url + '/api/getMasterCatalogVendorNames';
    return this.http.get<any>(url, { headers: this.authHeaders() });
  }

  syncMasterRecent() {
    const url = environment.auth_url + '/api/syncMasterRecent';
    return this.http.get<any>(url, { headers: this.authHeaders() });
  }

  syncMasterFull() {
    const url = environment.auth_url + '/api/syncMasterFull';
    return this.http.get<any>(url, { headers: this.authHeaders() });
  }

  getSyncMasterStatus(jobId: string) {
    const url = environment.auth_url + '/api/syncMasterStatus?job_id=' + encodeURIComponent(jobId);
    return this.http.get<any>(url, { headers: this.authHeaders() });
  }

  cancelSyncMaster(jobId: string) {
    const url = environment.auth_url + '/api/cancelSyncMaster?job_id=' + encodeURIComponent(jobId);
    return this.http.post<any>(url, {}, { headers: this.authHeaders() });
  }

  getMasterCatalog(startId: number = 0, filters: MasterCatalogFilters = {}, limit: number = 10) {
    const body = {
      start_id: startId,
      limit,
      item_code: filters.item_code || '',
      item_name: filters.item_name || '',
      barcode: filters.barcode || '',
      vendor_code: filters.vendor_code || '',
      vendor_name: filters.vendor_name || '',
      vendor_item_code: filters.vendor_item_code || ''
    };
    const url = environment.auth_url + '/api/getMasterCatalog';
    return this.http.post<any>(url, body, { headers: this.authHeaders() });
  }

  syncMasterSuppliers() {
    const url = environment.auth_url + '/api/syncMasterSuppliers';
    return this.http.get<any>(url, { headers: this.authHeaders() });
  }

  getSyncMasterSuppliersStatus(jobId: string) {
    const url = environment.auth_url + '/api/syncMasterSuppliersStatus?job_id=' + encodeURIComponent(jobId);
    return this.http.get<any>(url, { headers: this.authHeaders() });
  }

  cancelSyncMasterSuppliers(jobId: string) {
    const url = environment.auth_url + '/api/cancelSyncMasterSuppliers?job_id=' + encodeURIComponent(jobId);
    return this.http.post<any>(url, {}, { headers: this.authHeaders() });
  }

  getMasterSuppliers(startId: number = 0, filters: MasterSuppliersFilters = {}, limit: number = 10) {
    const body = {
      start_id: startId,
      limit,
      supplier_id: filters.supplier_id || '',
      supplier_name: filters.supplier_name || '',
      supplier_erp_code: filters.supplier_erp_code || '',
      status: filters.status || ''
    };
    const url = environment.auth_url + '/api/getMasterSuppliers';
    return this.http.post<any>(url, body, { headers: this.authHeaders() });
  }
}
